export const categories = {
    "Adventure": "Adventure",
    "Dystopia": "Dystopia",
    "Fantasy": "Fantasy",
    "Gothic": "Gothic",
    "Mystery": "Mystery",
    "Philosophy": "Philosophy",
    "Romance": "Romance",
    "SciFi": "SciFi"
};

export const bookList = [
    {
        "name": "1984",
        "title": "1984",
        "author": "George Orwell",
        "prodReady": true,
        "category": [
            "Philosophy",
            "SciFi",
            "Dystopia"
        ],
        "publishDate": "1949-01-01",
        "bites": [
            3,
            3,
            4,
            3,
            1
        ],
        "chapters": [24],
        "holoColors": "e1b741,ffffff",
        "accent": "#0dc9c9",
        "t": 293
    },
    {
        "name": "alice",
        "title": "Alice’s Adventures in Wonderland",
        "author": "Lewis Carroll",
        "prodReady": true,
        "category": [
            "Fantasy",
            "Adventure"
        ],
        "publishDate": "1865-01-01",
        "bites": [
            3,
            3,
            3,
            3
        ],
        "chapters": [12],
        "holoColors": "e8b0e6,43df97",
        "accent": "#00d6d6",
        "t": 233
    },
    {
        "name": "art-of-war",
        "title": "The Art of War",
        "author": "Sun Tzu",
        "prodReady": true,
        "category": [
            "Philosophy"
        ],
        "publishDate": "-0500-01-01",
        "bites": [
            3,
            3,
            4,
            3
        ],
        "chapters": [13],
        "holoColors": "f8c920,ff6600",
        "accent": "#f58c00",
        "t": 254
    },
    {
        "name": "artemis",
        "title": "Artemis",
        "author": "Andy Weir",
        "prodReady": false,
        "category": [
            "SciFi"
        ],
        "publishDate": "2017-01-01",
        "holoColors": "56e6f0,f53d74"
    },
    {
        "name": "asoiaf",
        "title": "A Game of Thrones",
        "author": "George R. R. Martin",
        "prodReady": false,
        "category": [
            "Fantasy"
        ],
        "publishDate": "1996-01-01",
        "bites": [
            3,
            3,
            3,
            3,
            3
        ],
        "holoColors": "f19137,ffffff"
    },
    {
        "name": "atomic-habits",
        "title": "Atomic Habits",
        "author": "James Clear",
        "prodReady": true,
        "category": [
            "Philosophy"
        ],
        "publishDate": "2018-01-01",
        "bites": [
            2,
            2,
            2,
            3,
            4
        ],
        "chapters": [20],
        "holoColors": "62cffe,c6dbf1",
        "accent": "#c9c90d",
        "t": 248
    },
    {
        "name": "brave-new-world",
        "title": "Brave New World",
        "author": "Aldous Huxley",
        "prodReady": true,
        "category": [
            "Philosophy",
            "SciFi",
            "Dystopia"
        ],
        "publishDate": "1932-01-01",
        "bites": [
            2,
            2,
            3,
            3,
            4
        ],
        "chapters": [18],
        "holoColors": "e9c89b,52987a",
        "accent": "#00d6d6",
        "t": 314
    },
    {
        "name": "curious-incident",
        "title": "The Curious Incident of the Dog in the Night-Time",
        "author": "Mark Haddon",
        "prodReady": false,
        "category": [
            "Mystery"
        ],
        "publishDate": "2003-01-01",
        "holoColors": "1993b3,4b9cdd"
    },
    {
        "name": "dark-forest",
        "title": "The Dark Forest",
        "author": "Cixin Liu",
        "prodReady": false,
        "category": [
            "SciFi"
        ],
        "publishDate": "2008-01-01",
        "holoColors": "fffcfa,000000"
    },
    {
        "name": "don-quixote",
        "title": "Don Quixote",
        "author": "Miguel de Cervantes",
        "prodReady": false,
        "category": [
            "Adventure"
        ],
        "publishDate": "1605-01-01",
        "bites": [
            1,
            3,
            3,
            3,
            5
        ]
    },
    {
        "name": "dracula",
        "title": "Dracula",
        "author": "Bram Stoker",
        "prodReady": true,
        "category": [
            "Gothic"
        ],
        "publishDate": "1897-01-01",
        "bites": [
            3,
            3,
            3,
            4,
            2
        ],
        "chapters": [27],
        "holoColors": "f13737,ecbb8e",
        "accent": "#d60000",
        "t": 362
    },
    {
        "name": "dune",
        "title": "Dune",
        "author": "Frank Herbert",
        "prodReady": false,
        "category": [
            "SciFi"
        ],
        "publishDate": "1965-01-01",
        "holoColors": "f1bd65,170707"
    },
    {
        "name": "fourth-wing",
        "title": "Fourth Wing",
        "author": "Rebecca Yarros",
        "prodReady": false,
        "category": [
            "Fantasy",
            "Romance"
        ],
        "publishDate": "2023-01-01",
        "holoColors": "31929b,c14949"
    },
    {
        "name": "frankenstein",
        "title": "Frankenstein",
        "author": "Mary Shelley",
        "prodReady": true,
        "category": [
            "Gothic",
            "SciFi"
        ],
        "publishDate": "1818-01-01",
        "bites": [
            3,
            3,
            4,
            3,
            2
        ],
        "chapters": [24],
        "holoColors": "a0df77,c395e9",
        "accent": "#00d6d6",
        "t": 333
    },
    {
        "name": "girl-with-dragon-tattoo",
        "title": "The Girl with the Dragon Tattoo",
        "author": "Stieg Larsson",
        "prodReady": false,
        "category": [
            "Mystery"
        ],
        "publishDate": "2005-01-01",
        "holoColors": "318d9b,60a2c8"
    },
    {
        "name": "harry-potter",
        "title": "Harry Potter and the Philosopher's Stone",
        "author": "J. K. Rowling",
        "prodReady": true,
        "category": [
            "Fantasy",
            "Adventure"
        ],
        "publishDate": "1997-01-01",
        "bites": [
            3,
            3,
            3,
            2,
            4
        ],
        "chapters": [17],
        "holoColors": "14dbf5,e6f7a6",
        "accent": "#00d6d6",
        "t": 364
    },
    {
        "name": "hitchhikers-guide",
        "title": "The Hitchhiker's Guide to the Galaxy",
        "author": "Douglas Adams",
        "prodReady": false,
        "category": [
            "SciFi"
        ],
        "publishDate": "1979-01-01",
        "holoColors": "fafeff,ffffff"
    },
    {
        "name": "hobbit",
        "title": "The Hobbit",
        "author": "J. R. R. Tolkien",
        "prodReady": false,
        "category": [
            "Fantasy",
            "Adventure"
        ],
        "publishDate": "1937-01-01",
        "bites": [
            3,
            3,
            3,
            4,
            2
        ],
        "holoColors": "f5fcff,ffffff"
    },
    {
        "name": "hunger-games",
        "title": "The Hunger Games",
        "author": "Suzanne Collins",
        "prodReady": true,
        "category": [
            "SciFi",
            "Adventure",
            "Dystopia"
        ],
        "publishDate": "2008-01-01",
        "bites": [
            3,
            3,
            3,
            3,
            3
        ],
        "chapters": [27],
        "holoColors": "f1d837,83d7fc",
        "accent": "#ff9d0a",
        "t": 286
    },
    {
        "name": "little-women",
        "title": "Little Women",
        "author": "Louisa May Alcott",
        "prodReady": false,
        "category": [
            "Romance"
        ],
        "publishDate": "1868-01-01",
        "bites": [
            3,
            2,
            2,
            3,
            3
        ],
        "holoColors": "f35ee6,fff70a"
    },
    {
        "name": "meditations",
        "title": "Meditations",
        "author": "Marcus Aurelius",
        "prodReady": false,
        "category": [
            "Philosophy"
        ],
        "publishDate": "0155-01-01",
        "bites": [
            3,
            3,
            3,
            2,
            1
        ]
    },
    {
        "name": "moby-dick",
        "title": "Moby Dick",
        "author": "Herman Melville",
        "prodReady": false,
        "category": [
            "Adventure"
        ],
        "publishDate": "1851-01-01",
        "bites": [
            3,
            2,
            2,
            2,
            3
        ]
    },
    {
        "name": "narnia",
        "title": "The Lion, the Witch and the Wardrobe",
        "author": "C. S. Lewis",
        "prodReady": false,
        "category": [
            "Fantasy",
            "Adventure"
        ],
        "publishDate": "1950-01-01",
        "bites": [
            3,
            3,
            2,
            3,
            2
        ]
    },
    {
        "name": "odyssey",
        "title": "The Odyssey",
        "author": "Homer",
        "prodReady": true,
        "category": [
            "Adventure"
        ],
        "publishDate": "-0700-01-01",
        "bites": [
            2,
            2,
            4,
            4,
            3
        ],
        "chapters": [24, "Books"],
        "holoColors": "ffae00,72a4f3",
        "accent": "#006bd6",
        "t": 488
    },
    {
        "name": "pride-and-prejudice",
        "title": "Pride and Prejudice",
        "author": "Jane Austen",
        "prodReady": false,
        "category": [
            "Romance"
        ],
        "publishDate": "1813-01-01",
        "bites": [
            3,
            3,
            3,
            3,
            2
        ],
        "holoColors": "f48be0,d4ff00"
    },
    {
        "name": "sapiens",
        "title": "Sapiens",
        "author": "Yuval Noah Harari",
        "prodReady": false,
        "category": [
            "Philosophy"
        ],
        "publishDate": "2011-01-01",
        "holoColors": "2ca07e,ffffff"
    },
    {
        "name": "sherlock-holmes",
        "title": "The Adventures of Sherlock Holmes",
        "author": "Arthur Conan Doyle",
        "prodReady": false,
        "category": [
            "Mystery",
            "Adventure"
        ],
        "publishDate": "1892-01-01",
        "bites": [
            3,
            3,
            3,
            3
        ],
        "holoColors": "e0fbff,ffffff"
    },
    {
        "name": "subtle-art",
        "title": "The Subtle Art of Not Giving a F*ck",
        "author": "Mark Manson",
        "prodReady": false,
        "category": [
            "Philosophy"
        ],
        "publishDate": "2016-01-01",
        "holoColors": "ba6b12,e3bd45"
    },
    {
        "name": "the-prince",
        "title": "The Prince",
        "author": "Niccolò Machiavelli",
        "prodReady": false,
        "category": [
            "Philosophy"
        ],
        "publishDate": "1532-01-01",
        "bites": [
            2,
            2,
            2,
            4,
            2
        ],
        "holoColors": "f50505,ff8800"
    },
    {
        "name": "verity",
        "title": "Verity",
        "author": "Colleen Hoover",
        "prodReady": false,
        "category": [
            "Romance",
            "Gothic"
        ],
        "publishDate": "2018-01-01",
        "holoColors": "ff4000,8941e1"
    }
]

export function getBookTitleParts(title) {
    if (!title) return null;

    const aliceMatch = title.match(/^(Alice['’]s)\s+(.+)$/i);
    if (aliceMatch) {
        return { main: aliceMatch[1], small: aliceMatch[2] };
    }

    const harryMatch = title.match(/^(Harry Potter)\s+(and the\s.+)$/i);
    if (harryMatch) {
        return { main: harryMatch[1], small: harryMatch[2] };
    }

    return null;
}

export function toRoman(num) {
    const values = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
    const numerals = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"];
    let result = "";
    for (let i = 0; i < values.length; i++) {
        while (num >= values[i]) {
            result += numerals[i];
            num -= values[i];
        }
    }
    return result;
}

export function normalizeBookBites(data) {
    if (Array.isArray(data)) return data;
    if (!data?.parts || !Array.isArray(data.bitesTranscription)) return [];

    const biteSyncs = [];
    const biteTransitionTimes = [];
    const biteTitleStarts = [];
    let introSync = null;
    let current = null;
    let inTitle = false;
    let prevWordEnd = null;
    let seenFirstBTitle = false;

    for (const entry of data.bitesTranscription) {
        const tags = entry.slice(3);
        if (tags.includes('bookTitle')) continue;
        if (tags.includes('bTitle')) {
            if (!inTitle) {
                if (!seenFirstBTitle) {
                    introSync = current;
                    seenFirstBTitle = true;
                } else if (current !== null) {
                    biteSyncs.push(current);
                }
                current = [];
                inTitle = true;
                const bTitleStart = entry[0];
                const transition = (prevWordEnd != null && Number.isFinite(bTitleStart))
                    ? prevWordEnd + (bTitleStart - prevWordEnd) * 0.35
                    : bTitleStart;
                biteTransitionTimes.push(transition);
                biteTitleStarts.push(bTitleStart);
            }
            continue;
        }
        inTitle = false;
        if (current === null) current = [];
        current.push(entry);
        prevWordEnd = entry[1];
    }
    if (current !== null) biteSyncs.push(current);

    let biteIndex = 0;
    const parts = data.parts.map((part) => ({
        ...part,
        bites: part.bites.map((bite) => {
            const i = biteIndex++;
            const transitionTime = biteTransitionTimes[i];
            const bTitleStart = biteTitleStarts[i];
            return {
                ...bite,
                transcriptionSync: biteSyncs[i] || [],
                audioStart: Number.isFinite(transitionTime) ? transitionTime : null,
                bTitleStart: Number.isFinite(bTitleStart) ? bTitleStart : null,
            };
        }),
    }));

    if (introSync && introSync.length > 0) {
        parts.introSync = introSync;
    }

    return parts;
}

export function getBiteIndexFromTime(time, biteStartTimes) {
    if (!Array.isArray(biteStartTimes) || biteStartTimes.length === 0) return null;
    if (!Number.isFinite(time)) return null;
    const firstStart = biteStartTimes[0];
    if (Number.isFinite(firstStart) && time < firstStart) return null;
    let index = 0;
    for (let i = 0; i < biteStartTimes.length; i++) {
        const start = biteStartTimes[i];
        if (Number.isFinite(start) && time >= start) index = i;
    }
    return index;
}

export function formatTime(seconds) {
    if (!Number.isFinite(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function scrollChildIntoCenter(scrollParent, child, behavior = "smooth") {
    if (!scrollParent || !child) return;
    const parentRect = scrollParent.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();
    if (childRect.top >= parentRect.top && childRect.bottom <= parentRect.bottom) return;
    const top =
        childRect.top -
        parentRect.top -
        parentRect.height / 2 +
        childRect.height / 2 +
        scrollParent.scrollTop;
    scrollParent.scrollTo({ top, behavior });
}
